import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    modalId: { type: String, default: "leave-club-member-modal" },
    formId: { type: String, default: "leave-club-member-form" }
  }

  connect() {
    this.modal = document.getElementById(this.modalIdValue)
    this.form = document.getElementById(this.formIdValue)
    this.descEl = document.getElementById("leave-club-member-modal-desc")
    this.element.addEventListener("click", this.open.bind(this))
  }

  open(e) {
    e.preventDefault()
    const url = this.element.dataset.membershipUrl
    const userName = this.element.dataset.userName || ""
    if (!url || !this.form) return

    this.form.action = url

    if (this.descEl && this.descEl.dataset.template) {
      this.descEl.textContent = this.descEl.dataset.template.replace("%{name}", userName || "")
    }

    if (this.modal && typeof UIkit !== "undefined") {
      UIkit.modal(this.modal).show()
    }
  }
}
